import { render } from "./investor.vue?vue&type=template&id=0c563d2a&scoped=true"
import script from "./investor.vue?vue&type=script&lang=js"
export * from "./investor.vue?vue&type=script&lang=js"

import "./investor.vue?vue&type=style&index=0&id=0c563d2a&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c563d2a"]])

export default __exports__